export var Severity = /*#__PURE__*/ function(Severity) {
    // in order of severity
    Severity["CRITICAL"] = "CRITICAL";
    Severity["ERROR"] = "ERROR";
    Severity["DEBUG"] = "DEBUG";
    return Severity;
}({});
export var NodeErrorSeverity = /*#__PURE__*/ function(NodeErrorSeverity) {
    NodeErrorSeverity["CRITICAL"] = "CRITICAL";
    NodeErrorSeverity["DEBUG"] = "DEBUG";
    NodeErrorSeverity["ERROR"] = "ERROR";
    NodeErrorSeverity["INFO"] = "INFO";
    NodeErrorSeverity["WARNING"] = "WARNING";
    return NodeErrorSeverity;
}({});
export var ActionSeverity = /*#__PURE__*/ function(ActionSeverity) {
    ActionSeverity["WARNING"] = "WARNING";
    ActionSeverity["INFO"] = "INFO";
    return ActionSeverity;
}({});
// This enum is used strictly for typing purposes. If you need to reference a team identifier (e.g., team name),
// use the TeamInfo object instead. For example, when capturing an error, you should reference the team name like this:
// captureError(error, { teamName: TeamInfo["TeamNames.CWF"].name })
export var TeamNames = /*#__PURE__*/ function(TeamNames) {
    TeamNames["ADS"] = "FT-Ads";
    TeamNames["CMW"] = "FT-Garuda";
    TeamNames["CW"] = "FT-CommerceWeb";
    TeamNames["CWF"] = "FT-CWF";
    TeamNames["ECOMMERCE"] = "FT-Ecommerce";
    TeamNames["FLAPJACK"] = "FT-Flapjack";
    TeamNames["GROWTH_A"] = "FT-Growth";
    TeamNames["HACKWORTH"] = "FT-Hackworth";
    TeamNames["MANDALORIANS"] = "FT-Mandalorians";
    TeamNames["MEMBERSHIP"] = "FT-GateKeepers";
    TeamNames["MYAC"] = "FT-MyAccount";
    TeamNames["NEXUS"] = "FT-Nexus";
    TeamNames["NITEHAWK"] = "FT-Nitehawk";
    TeamNames["OCTOPUS"] = "FT-Octopus";
    TeamNames["PACMAN"] = "FT-Pacman";
    TeamNames["SEARCH"] = "FT-Search";
    TeamNames["TITANS"] = "FT-Titans";
    TeamNames["WT"] = "FT-Rigel";
    TeamNames["VERVE"] = "FT-Verve";
    TeamNames["VSE"] = "FT-ValuedSubscription";
    TeamNames["CQNA"] = "FT-CQNA";
    TeamNames["SAR"] = "FT-SearchAndRec";
    return TeamNames;
}({});
